module.exports = __webpack_public_path__ + "img/Banner_1080x200_GiftCard.2e11c7b0.png";